module.exports = __webpack_public_path__ + "img/switch-refuse.0f034b16.png";